import "./Header.scss";
import BistatechLogo from "../../assets/images/bistatech-logo.png";
import { useEffect, useState } from "react";
import { checkUserAuthentication } from "functions/functions";
import LoginInDialog from "components/Login/LoginInDialog";
import useCheckRoute from "ccustomHook/useCheckRoute";

const Header = () => {
  // check if user's token not valid, show login dialog box
  const [authenticationIsExpired, setAuthenticationIsExpired] = useState(false);

  const userTokenIsValid = async () => {
    const auth = await checkUserAuthentication();
    setAuthenticationIsExpired(!auth);
  };

  useEffect(() => {
    setTimeout(() => {
      userTokenIsValid();
    }, 2000);
  }, []);

  return (
    // function for check path (path start with entry value, it return True or False)
    useCheckRoute("/login") ? null : (
      <>
        <div className="navigation-img-container ">
          <img
            className="navigation-header-img"
            src={BistatechLogo}
            alt="bistatech-logo"
          />
        </div>
        {/* show login dialog box if token invalid and current page is not "login" */}
        {authenticationIsExpired && <LoginInDialog />}
      </>
    )
  );
};
export default Header;